import React, { FC, useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import MemberTable from '../../components/members/MemberTable';
import MemberPortfolio from '../../components/members/MemberPortfolio';
import { Server } from '../../services/Server';
import './Members.css';
import { addCalculatedStats } from '../../components/portfolio/addCalculatedStats';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';
import { User } from '../../../../api/src/interfaces/shared';

const Members: FC = () => {
  const [members, setMembers] = useState<User[]>();
  const [membersLoaded, setMembersLoaded] = useState<boolean>(false);
  const [showMember, setShowMember] = useState<boolean>(false);
  const [memberAssets, setMemberAssets] = useState<
    AssetWithCalculatedStats[]
  >();
  const [member, setMember] = useState<User>();
  const [memberLoaded, setMemberLoaded] = useState<boolean>(false);

  const loadMembers = async () => {
    const allMembers = await Server.getAllMembers();
    setMembers(allMembers);
    setMembersLoaded(true);
  };

  const loadMemberPortfolio = async (member: User) => {
    const memberPortfolio = await Server.getMemberPortfolio(member.id);
    const assets = memberPortfolio.map(addCalculatedStats);
    setMemberAssets(assets);
    setMember(member);
    setMemberLoaded(true);
  };

  const onMemberClick = (member: User) => {
    setMemberLoaded(false);
    setShowMember(true);
    loadMemberPortfolio(member);
  };

  const hideMember = () => {
    setShowMember(false);
  };

  useEffect(() => {
    loadMembers();
  }, []);

  if (membersLoaded && !showMember && members) {
    return (
      <Row>
        <MemberTable members={members} onMemberClick={onMemberClick} />
      </Row>
    );
  }
  if (memberLoaded && showMember && member && memberAssets) {
    return (
      <Row>
        <MemberPortfolio
          member={member}
          assets={memberAssets}
          hide={hideMember}
        />
      </Row>
    );
  }
  return (
    <Row>
      <div className="box">
        <Loader />
      </div>
    </Row>
  );
};

export default Members;
